import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class SessionService {
  private readonly authSessionKey = '_HIGHDMIN_AUTH_SESSION_KEY_';
  private readonly expiresAtKey = '_HIGHDMIN_EXPIRES_AT_';
  private logoutTimer?: ReturnType<typeof setTimeout>;

  constructor(private cookieService: CookieService) {}

  get session(): string {
    return this.cookieService.get(this.authSessionKey);
  }

  public saveSession(token: string, expiresIn: number): void {
    const expiresAt = Date.now() + expiresIn * 1000;
    this.cookieService.set(this.authSessionKey, token, undefined, '/');
    localStorage.setItem(this.expiresAtKey, expiresAt.toString());
    this.startLogoutTimer(expiresIn);
  }

  public removeSession(): void {
    this.clearLogoutTimer();
    this.cookieService.delete(this.authSessionKey, '/');
    localStorage.removeItem(this.expiresAtKey);
  }

  public isSessionExpired(): boolean {
    const expiresAt = localStorage.getItem(this.expiresAtKey);
    return expiresAt ? Date.now() > Number(expiresAt) : true;
  }

  public restoreSessionTimer(): void {
    const expiresAt = localStorage.getItem(this.expiresAtKey);
    if (!expiresAt) return;
    const remaining = Number(expiresAt) - Date.now();
    if (remaining > 0) this.startLogoutTimer(remaining / 1000);
    else this.removeSession();
  }

  private startLogoutTimer(seconds: number): void {
    this.clearLogoutTimer();
    this.logoutTimer = setTimeout(() => {
      this.removeSession();
      window.location.href = '/auth/login';
    }, seconds * 1000);
  }

  private clearLogoutTimer(): void {
    if (this.logoutTimer) {
      clearTimeout(this.logoutTimer);
      this.logoutTimer = undefined;
    }
  }
}
